import { render } from "./PatientInfo.vue?vue&type=template&id=5394749a&scoped=true&ts=true"
import script from "./PatientInfo.vue?vue&type=script&lang=ts"
export * from "./PatientInfo.vue?vue&type=script&lang=ts"

import "./PatientInfo.vue?vue&type=style&index=0&id=5394749a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5394749a"]])

export default __exports__